import { AxiosInstance } from 'axios';
import { Token, User } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'token';

export class TokenApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async login(params: LoginParams): Promise<Token> {
    await simulate();
    const response = await this.apiInstance.post('/login', params);

    return response.data;
  }

  async register(params: LoginParams): Promise<Token> {
    await simulate();
    const response = await this.apiInstance.post('/register', params);

    return response.data;
  }

  async verify(params: { token: string }): Promise<User> {
    await simulate();

    const response = await this.apiInstance.get(`/verify?token=${params.token}`);

    return response.data;
  }

  async refresh(): Promise<User> {
    await simulate();

    const response = await this.apiInstance.post('/refresh');

    return response.data;
  }

  async logout(): Promise<Token> {
    await simulate();

    const response = await this.apiInstance.post(`/logout`);

    return response.data;
  }

  async googleAuthentication(vals: {
    credential: string;
    secret?: string | null;
  }): Promise<{ verificationToken: string }> {
    await simulate();

    const response = await this.apiInstance.post(`/auth/google-token`, vals);

    return response.data;
  }
}

export type LoginParams = {
  email: string;
  secret?: string;
};
